import { h, Component } from 'preact';
import { Icon } from '@cube/blocks';
import { withLocationModel } from '@cube/location-model';
import { Text } from 'preact-i18n';
import { MAX_FAVORITES } from '../../constants';
import style from './style';
import cx from 'classnames';

// Consider moving MAX_FAVORITES to the model.
// Consider adding "is.full.favorites" and "is.full.recent"
export class CurrentLocation extends Component {

	handleAddFavorite = () => {
		const { favorites = [], current, onChangeFavorites, maxFavorites } = this.props;
		const isFavoritesFull = favorites.length >= maxFavorites;
		!isFavoritesFull && onChangeFavorites && onChangeFavorites(favorites.concat(current));
	};

	handleRemoveFavorite = () => {
		const { favorites = [], isCurrent, isCurrentPrimary, onChangeFavorites } = this.props;

		!isCurrentPrimary && onChangeFavorites && onChangeFavorites(favorites.filter((favorite) => isCurrent && !isCurrent(favorite)));
	};

	static defaultProps = {
		maxFavorites: MAX_FAVORITES
	};

	render({ current = {}, favorites = [], isCurrentInFavorites, isCurrentPrimary, onChangeFavorites, ...props }) {
		const isFavoritesFull = favorites.length >= MAX_FAVORITES;

		return (
			<button {...props} class={cx(style.button, props.class)} onClick={!isCurrentInFavorites ? this.handleAddFavorite : this.handleRemoveFavorite}>
				<p class={style.truncate}>{current.name || <Text id="currentLocation" />}</p>
				<Icon
					class={cx(style.icon, isCurrentInFavorites ? !isCurrentPrimary && style.favorited : isFavoritesFull && style.full)}
					name={isCurrentPrimary ? 'current-location-wire-cube' : 'star-cube'}
				/>
			</button>
		);
	}
}

function enhance(Child) {
	return withLocationModel(
		({ current, favorites }) => ({ current, favorites }),
		(model, ownProps) => ({
			onChangeFavorites: model.actions.change.favorites,
			isCurrentInFavorites: model.is.favorites(ownProps.current),
			isCurrentPrimary: model.is.primary(ownProps.current),
			isCurrent: model.is.current
		})
	)(
		Child
	);
}

export default enhance(CurrentLocation);
